export const formsWrapper = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",
};
export const formsContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: "16px",
  gap: "16px",
  borderRadius: "8px",
  border: "1px solid var(--text-disabled-e-5-e-5-e-5, #E5E5E5)",
  alignSelf: "stretch",
};
export const titleStyles = {
  color: "var(--typography-graphics-dark-gray-595959, #595959)",
  fontFamily: "Roboto Condensed",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
};
export const noFormsText = {
  color: "var(--typography-graphics-dark-gray-595959, #595959)",
  fontFamily: "Roboto Condensed",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
};
